export const getUrlGetParams = () => {
  return window.location.search
    .slice(1)
    .split('&')
    .reduce<{ [key: string]: string }>((result, param) => {
      const keyValue = param.split('=');
      return { ...result, [keyValue[0]]: keyValue[1] };
    }, {});
};
